/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core';
import {translate} from '@ion/core/src/locale/locale';
import {
  FormItem
} from '@ion/dls/src/components/forms/FormItem';
import {
  FormTextField
} from '@ion/dls/src/components/forms/FormTextField';
import {GroupAssignmentAccountChooserProps} from './GroupAssignmentAccountChooser';

export interface NewGroupAssignmentActionProps extends GroupAssignmentAccountChooserProps {}

const useStyles = makeStyles(() => ({
  paddingTop : {
    paddingTop : '15px'
  },
  paddingTopBottom : {
    padding : '15px 0 20px'
  }
}));

/**
 * Re-usable hook for adding new group.
 */
export const NewGroupAssignmentAction = ({
  groupName,
  groupNotes,
  path,
  handleGroupNameChooser,
  handleGroupNotesChooser,
  isGroupNameEmpty = false,
  isGroupNameExists = false,
  areGroupsLoading = false
}: NewGroupAssignmentActionProps) => {
  const classes = useStyles();

  if (!areGroupsLoading) {
    return (
      <>
        <FormItem fullWidth className={classes.paddingTop}>
          <FormTextField required
            name={'groupName'}
            fieldLabel={translate(`${path}.groupName.label`)}
            placeholder={translate(`${path}.groupName.placeholder`)}
            onChange={function(event) {
              handleGroupNameChooser(event?.target?.value);
            }}
            hasError={isGroupNameEmpty || isGroupNameExists}
            errorText={!groupName
              ? translate('common:editors.shared.required')
              : translate(`${path}.groupName.error`)}
            value={groupName || ''}
            maxLength={64} />
        </FormItem>
        <FormItem fullWidth className={classes.paddingTopBottom}>
          <FormTextField name={'notes'}
            fieldLabel={translate(`${path}.notes.label`)}
            placeholder={translate(`${path}.notes.placeholder`)}
            onChange={function(event) {
              handleGroupNotesChooser(event?.target?.value);
            }}
            hasError={groupNotes?.length > 1024}
            errorText={translate(`${path}.notes.error`)}
            value={groupNotes}
            maxLength={1024} />
        </FormItem>
      </>
    );
  }
};

export default NewGroupAssignmentAction;
